import { render, staticRenderFns } from "./modalView.vue?vue&type=template&id=ff6d7e4c&scoped=true"
import script from "./modalView.vue?vue&type=script&lang=js"
export * from "./modalView.vue?vue&type=script&lang=js"
import style0 from "./modalView.vue?vue&type=style&index=0&id=ff6d7e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6d7e4c",
  null
  
)

export default component.exports